import axios from "axios";
import Config from "../Config";

const formatSuccess = (res: any) => {
    return res.data;
};
const baseUrl = Config.baseUrl;

const formatResponse = (data: any) => {
    return new Promise((resolve, reject) => {
        data
            .then((res: any) => resolve(formatSuccess(res)))
            .catch((err: any) => reject(err));
    });
};

export const getApi = (url: string, params: string = "") => {
    // const headers = getHeaders();
    const axiosCall = axios.get(baseUrl + url + params);
    return formatResponse(axiosCall);
};

export const postApi = (url: string, json: any) => {
    // const headers = getHeaders();
    const axiosCall = axios.post(baseUrl + url, json);
    return formatResponse(axiosCall);
};

export const putApi = (url: string, json: any) => {
    // const headers = getHeaders();
    const axiosCall = axios.put(baseUrl + url, json);
    return formatResponse(axiosCall);
};

export const deleteApi = (url: string) => {
    // const headers = getHeaders();
    const axiosCall = axios.delete(baseUrl + url);
    return formatResponse(axiosCall);
};